import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import Helmet from 'react-helmet';

import { ArticleListAd } from './ad';
import Static from './static';
import A from './a';
import Heading from './heading';
import ImagePreloader from './image-preloader';
import { capitalize, truncate, buildTagLink } from '../utilities/formatting';

const buildArticleList = (articleList, forAwards, pathname, forData) => (
    <ul
        css={{
            listStyle: 'none',
            padding: 0,
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
            gridGap: 24,
        }}
    >
        {articleList.map(({ image, body, title, tags, date, uid }) => (
            <li css={{ margin: 0 }} key={uid}>
                <div
                    css={{
                        display: 'flex',
                        position: 'relative',
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <div css={{ width: '100%', marginBottom: 24, height: 200, position: 'relative' }}>
                        <Img fluid={image.localFile.childImageSharp.fluid} css={{ height: 200 }} />
                        <Link
                            to={`/${forAwards ? 'wyse-awards' : (forData ? 'data' : 'articles')}/${uid}`}
                            css={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                left: 0,
                                bottom: 0,
                            }}
                        />
                    </div>
                    <div>
                        <h4 css={{ marginTop: 0, marginBottom: 4 }}>
                            <Link css={{ color: '#333' }} to={`/${forAwards ? 'wyse-awards' : (forData ? 'data' : 'articles')}/${uid}`}>{title}</Link>
                        </h4>
                        <div css={{ display: 'flex', alignItems: 'center' }}>
                            <span css={{ color: '#c1c0c0', marginRight: 12 }}>{date}</span>
                            {tags && tags.slice(0, 3).map((tag, index) => (
                                <Link
                                    to={buildTagLink(tag, forAwards)}
                                    key={index}
                                    css={{
                                        borderRadius: 8,
                                        background: '#70ccf3',
                                        padding: '2px 8px',
                                        marginRight: 8,
                                        fontSize: 11,
                                        color: '#333',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {tag}
                                </Link>
                            ))}
                            {tags && tags.length > 3 && <span>+ {tags.length - 3} more</span>}
                        </div>
                        <p
                            css={{
                                marginTop: 8,
                                marginBottom: 0,
                            }}
                        >{truncate(body)} <span css={{ whiteSpace: 'nowrap' }}><A href={`/${forAwards ? 'wyse-awards' : (forData ? 'data' : 'articles')}/${uid}`}>Read More</A></span></p>
                    </div>
                </div>
            </li>
        ))}
        {articleList.length % 2 !== 0 ? <ArticleListAd key={pathname} /> : null}
    </ul>
);

const ArticleListHeader = ({ children, category }) => (
    <Heading
        css={{
            marginTop: category ? 20 : 0,
            marginBottom: 20,
        }}
    >
        {children}
    </Heading>
);

export default ({ articleList, category, forAwards, forData, pathname }) => {
    let matchingArticles;
    let allArticles;

    // TODO: There's gotta be a cleaner way to do this!
    if (category) {
        matchingArticles = [];
        allArticles = [];

        for (let articleIndex = 0; articleIndex < articleList.length; articleIndex++) {
            const article = articleList[articleIndex];
            const tags = article.tags;
            let matchFound = false;

            for (let tagIndex = 0; tagIndex < article.tags.length; tagIndex++) {
                const tag = tags[tagIndex];

                if (tag.toLowerCase() === category.toLowerCase()) {
                    matchFound = true;
                }
            }

            if (matchFound) {
                matchingArticles.push(article);
            } else {
                allArticles.push(article);
            }
        }
    } else {
        allArticles = articleList;
    }

    const articleString = forAwards ? 'Wyse Awards' : (forData ? 'Data' : 'Articles');

    return (
        <div>
            <Helmet
                title={articleString}
                meta={[{ property: 'og:title', content: articleString }]}
            />
            {category &&
                <div>
                    <ArticleListHeader category={category}>{articleString} about {capitalize(category)}</ArticleListHeader>
                    <Static>
                        {matchingArticles.length ?
                            buildArticleList(matchingArticles, forAwards, pathname, forData) :
                            <p>No articles found about {capitalize(category)}</p>
                        }
                        {matchingArticles.length && matchingArticles.length % 2 === 0 ? <ArticleListAd key={pathname} /> : null}
                    </Static>
                </div>
            }
            {allArticles.length > 0 &&
                <div>
                    <ArticleListHeader category={category}>{category ? `Other ${articleString}` : articleString}</ArticleListHeader>
                    <Static>
                        {buildArticleList(allArticles, forAwards, pathname, forData)}
                        {allArticles.length && allArticles.length % 2 === 0 ? <ArticleListAd key={pathname} /> : null}
                    </Static>
                </div>
            }
        </div>
    );
};
